export default __webpack_public_path__ + "static/metamask.svg-30289624c0c1d284fbff5ca7695afe94.png";